export default __webpack_public_path__ + "static/media/sports.9253b5d7.JPG";